import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { pdpApiService } from 'src/app/services/pdp-api.service';
import { environment } from 'src/environments/environment';
import { GoogleAnalyticsEventsService } from "../../services/google-analytics.service";

@Component({
  selector: 'app-consent-withoutradio',
  templateUrl: './consent-withoutradio.component.html',
  styleUrls: ['./consent-withoutradio.component.css']
})
export class ConsentWithoutRadioComponent implements OnInit {
  @ViewChild('top') topPolicy!: ElementRef;
  @Input() consentType: number = 0;
  @Input() msisdn: string = ''
  @Input() signature: string = ''
  @Input() isAutoLogin: boolean = false

  currentlang: any;
  modalRef: any;
  drawerTncIoh: boolean = false;

  stateDialog: string = '';
  platform: any;
  showButton: boolean = false;

  constructor(
    public translate: TranslateService,
    private pdpService: pdpApiService,
    public googleAnalyticsService: GoogleAnalyticsEventsService,
  ) {
  }

  ngOnInit(): void {
    this.currentlang = localStorage.getItem('language');
    this.translate.use(this.currentlang);
    this.translate.setDefaultLang(this.currentlang);

    setTimeout(() => {
      this.platform = localStorage.getItem('platform');
    }, 100);
  }

  save(value: number) {
    let consentList = [];
    let responseGroup1 = value ? 'Y' : 'N';

    consentList.push({
      "consentGroup": "Contractual",
      "consentSubgroup": "Contractual",
      "response": 'Y'
    })
    consentList.push({
      "consentGroup": "Group1",
      "consentSubgroup": "Group1",
      "response": responseGroup1
    })

    this.googleAnalyticsService.emitEvent("Submit Consent", "MSISDN", '62' + this.msisdn);
    if (this.isAutoLogin) {
      // this.pdpService.updateConsentHash(this.msisdn, consentList).subscribe(res => {
      //   if (res.data.CustomerConsentServiceResp.status === "00000") {
      //     this.stateDialog = 'update_success'
      //     setTimeout(() => {
      //       this.showButton = this.platform === 'indosat' ? false : true;
      //     }, 100);
      //   }
      // }, err => {
      //   console.log(err)
      // })
    } else {
      // this.pdpService.updateConsent('62' + this.msisdn, consentList, this.signature).subscribe(res => {
      //   if (res.data.CustomerConsentServiceResp.status === "00000") {
      //     this.stateDialog = 'update_success'
      //   }
      // }, err => {
      //   console.log(err)
      // })
    }
  }

  btnAction() {
    let url = '';

    this.googleAnalyticsService.emitEvent("Got It Button", "platform", this.platform);
    if (this.platform.toLowerCase() === 'im3') {
      url = environment.im3HomePage
    } else {
      url = environment.bimaHomePage
    }

    console.log({ platform: this.platform, url });

    window.location.href = url;
  }

  learnMore(consent: string) {
    this.currentlang = localStorage.getItem('language');
    this.topPolicy.nativeElement.scrollIntoView();

    if (consent === 'ioh') {
      this.drawerTncIoh = true;
    } else {
      this.drawerTncIoh = false;
    }
  }

  manageConsent() {
    this.consentType = 0;
  }
}
